<template>
  <div class="content">
    <div class="step_content">
      <a-steps :current="current" :items="steps" @change="handleClickStep"></a-steps>
    </div>
    <div class="box">
      <div class="steps-content">
        <div v-if="steps[current].content===1">
          <StepCreate :currentMassEmailObj="currentMassEmailObj" ref="createTask"></StepCreate>
        </div>
        <div v-else-if="steps[current].content===2">
          <StepObject ref="tempObject"></StepObject>
        </div>
        <div v-else-if="steps[current].content===3">
          <StepContent :currentMassEmailObj="currentMassEmailObj" ref="emailContent"></StepContent>
        </div>
        <div v-else-if="steps[current].content===4">
          <StepForm :currentMassEmailObj="payloadFormEmail" ref="formContent"></StepForm>
        </div>
      </div>
      <div class="steps-action">
        <el-button v-if="current > 0" style="margin-left: 8px" @click="prev" :loading="isLoading">
          {{ $t('common.step.pre') }}
        </el-button>
        <el-button v-if="current < steps.length - 1" type="primary" @click="next" :loading="isLoading">
          {{ $t('common.step.next') }}
        </el-button>
        <el-button
            v-if="current === steps.length - 1"
            type="primary"
            :loading="loadingSend"
            @click="handleClickSend"
        >
          {{ $t('common.sent') }}
        </el-button>
      </div>
    </div>
  </div>
</template>
<script setup>
import {computed, nextTick, onMounted, reactive, ref, watch} from 'vue';
import {i18n} from "@/lang";
import StepCreate from "@/views/Marketing/StepCreate.vue";
import StepObject from "@/views/Marketing/StepObject.vue";
import StepContent from "@/views/Marketing/StepContent.vue";
import StepForm from "@/views/Marketing/StepForm.vue";
import {UserTable} from "@/views/Marketing/db_user";
import {getMailConfigList, getMassMailDetail, sendMassMail, sendMassMailUpdate} from "@/api";
import {ElMessage} from "element-plus";
import {useRoute, useRouter} from "vue-router";
import {batchDelayCancel, getGroupMassCustomerList, getRuleFilter} from "@/api/customer";
import {useStore} from "vuex";
import {debouncePlus, isEmpty, throttle} from "@/utils/mylodash";
import {TIME_OUT} from "@/utils/statusParams";
import {CustomerTable} from "@/views/Marketing/db_customer";
import sessionStore from "@/utils/sessionStore";
import {Storage} from "@/utils/storage";

const route = useRoute()
const router = useRouter()
const store = useStore()
// 整合所有的表单数据
const current = ref(Number(route.query.step) ?? 0)
// teamId
const teamId = computed(() => store.state.email.teamID);
// 邮件内容
const emailContent = ref(null)
const formContent = ref(null)
const isLoading = ref(false)
const createTask = ref(null)
const tempObject = ref(null)


const handleClickStep = async (val) => {
  console.log(val, 'val')
  const r0 = await step0Rules()
  if (r0 === false) return

  const r1 = await step1Rules()
  if (r1 === false) return

  const r2 = await step2Rules()
  if (r2 === false) return

  const r3 = await step3Rules()
  if (r3 === false) return

  // 更新步骤状态
  // updateStep(val)
  current.value = val
  sessionStore.set("STEP_CURRENT", current.value)
}

// 更新步骤条
const updateStep = (currentIndex) => {
  steps.value.forEach((step, index) => {
    if (index < currentIndex) {
      step.status = 'finish'
    } else if (index === currentIndex) {
      step.status = 'process'
    } else {
      step.status = 'wait'
    }
  })
}

const next = async () => {
  const rules = [step0Rules, step1Rules, step2Rules, step3Rules]
  for (const check of rules) {
    const passed = await check()
    if (passed === false) return
  }

  // 标记当前步骤完成
  // steps.value[current.value].status = 'finish'
  //
  // // 仅当不是最后一步时推进
  // if (current.value < steps.value.length - 1) {
  //   current.value++
  //   steps.value[current.value].status = 'process'
  // }
  current.value++
  sessionStore.set("STEP_CURRENT", current.value)
}

const prev = async () => {
  // 校验逻辑（按需保留）
  const rules = [step0Rules, step1Rules, step2Rules, step3Rules]
  for (const check of rules) {
    const passed = await check()
    if (passed === false) return
  }

  // 防止越界（第一步不再往前）
  if (current.value === 0) return

  // 当前步骤恢复为 wait 状态
  steps.value[current.value].status = 'wait'

  // 回退到上一步
  current.value--

  // 上一步标为 process
  steps.value[current.value].status = 'process'

  sessionStore.set("STEP_CURRENT", current.value)
}


const step0Rules = async () => {
  if (current.value === 0) {
    await nextTick()
    steps.value[current.value].status = "wait"
    const createTaskComp = createTask.value
    console.log(createTaskComp, createTaskComp.valueType, createTaskComp.selectType, 'createTaskComp')
    if (createTaskComp) {
      if (createTaskComp.valueType === "" || !(createTaskComp.selectType.key !== "")) {
        // ElMessage.warning(i18n.global.t('common.step.1.holder'))
        // return false
        steps.value[current.value].status = "error"
      } else {
        steps.value[current.value].status = "finish"
      }
    }
  }
}

const step1Rules = async () => {
  if (current.value === 1) {
    await nextTick()
    steps.value[current.value].status = "wait"
    const tempObjectComp = tempObject.value;
    if (tempObjectComp) {
      //  数据限制 最高7000条数据
      const max = tempObjectComp.maxNumber
      const total = tempObjectComp.totalsPublic
      if (total > max) {
        ElMessage.warning(i18n.global.t('common.step.3.holder', {maxCount: max}))
        steps.value[current.value].status = "error"
      } else if (total === 0) {
        // ElMessage.warning(i18n.global.t('common.email.inner'))
        steps.value[current.value].status = "error"
      } else {
        steps.value[current.value].status = "finish"
      }
      // else if (total === 0) {
      //   ElMessage.warning(i18n.global.t('common.email.inner'))
      //   return false
      // }
    }
  }
}

const step2Rules = async () => {
  if (current.value === 2) {
    // 等待 DOM 更新和子组件挂载完成
    await nextTick()
    steps.value[current.value].status = "wait"
    const stepComp = emailContent.value
    if (stepComp) {
      console.log(stepComp.isLoadingPage, 'stepComp.isLoadingPage')
      if (stepComp.isLoadingPage) {
        // ❌ 还没加载完
        isLoading.value = stepComp.isLoadingPage
        steps.value[current.value].status = "wait"
        return false
      } else {
        isLoading.value = stepComp.isLoadingPage
        await stepComp.handleSendMail()
        if (stepComp.emailFormData.text !== "") {
          steps.value[current.value].status = "finish"
        } else {
          steps.value[current.value].status = "error"
        }
        return true
      }
    }
  }
}

const step3Rules = async () => {
  if (current.value === 3) {
    await nextTick()
    steps.value[current.value].status = "wait"
    const stepComp = formContent.value
    if (stepComp) {
      sessionStore.set("STEP_3_EMAIL_FORM_DATA", stepComp.form)
      await stepComp.handleSubmitForm()
      const valid = stepComp.isValid;
      if (valid) {
        steps.value[current.value].status = "finish"
      } else {
        steps.value[current.value].status = "error"
      }
    }
  }
}

// 监听子组件 isLoadingPage
watch(
    () => emailContent.value?.isLoadingPage,
    (newVal) => {
      if (typeof newVal === 'boolean') {
        isLoading.value = newVal
      }
    },
    {immediate: true, deep: true}
)

watch(() => current.value, async (newValue) => {
  if (newValue) {
    await getSwitchDetailAPI()
  }
})


const steps = ref([
      {
        title: i18n.global.t('common.step.1'),
        content: 1,
        status: 'process',
      },
      {
        title: i18n.global.t('common.step.2'),
        content: 2,
        status: 'wait',
      },
      {
        title: i18n.global.t('common.step.3'),
        content: 3,
        status: 'wait',
      },
      {
        title: i18n.global.t('common.step.4'),
        content: 4,
        status: 'wait',
      },
    ]
)

// const items = steps.map(item => ({key: item.title, title: item.title, status: item.status}));


const loadingSend = ref(false)
// 区域列表
const areaList = computed(() => store.state.customer.areaList);

const handleClickSend = throttle(async () => {
  console.log(formContent, 'formContent')
  await nextTick()
  if (formContent.value) {
    await formContent.value.handleSubmitForm()
    const valid = formContent.value.isValid;
    console.log(valid, 'payload')
    if (valid) {
      await sessionStore.set("STEP_3_EMAIL_FORM_DATA", formContent.value.form)
      // 整合所有数据的个数
      const STEP_0_SELECT_TYPE = sessionStore.get("STEP_0_SELECT_TYPE");
      const STEP_0_SELECT_WAYS = sessionStore.get("STEP_0_SELECT_WAYS");
      const STEP_1_RULE = sessionStore.get("STEP_1_RULE");
      const STEP_2_EMAIL_FORM_DATA = sessionStore.get("STEP_2_EMAIL_FORM_DATA")
      const STEP_3_EMAIL_FORM_DATA = sessionStore.get("STEP_3_EMAIL_FORM_DATA")
      // console.log('pick', STEP_0_SELECT_TYPE, STEP_0_SELECT_WAYS, STEP_1_RULE, STEP_2_EMAIL_FORM_DATA, STEP_3_EMAIL_FORM_DATA)
      // 获取临时主义
      const allCustomer = await UserTable.getAll()
      console.log(allCustomer, 'allCustomer')

      // 联系人处理
      const customersToInsert = allCustomer.map(_ => {
        // 判断 id 是否有效
        const validId = _.customerId && _.customerId.toString().length >= 19 ? _.customerId : undefined;

        return {
          ...(validId ? {customerId: validId} : {}), // 只有有效 id 才加入 customerId
          email: _.email,
          isCheck: _.isCheck,
          name: _.contactName !== "" ? _.contactName : "",
          type: _.type,
          contactId: _.contactId,
          zoneAddress: _.zoneAddress,
        };
      });

      const payload = {
        massMarketType: STEP_0_SELECT_TYPE,
        massMailType: STEP_0_SELECT_WAYS,
        jsonString: JSON.stringify(STEP_1_RULE),
        ...STEP_2_EMAIL_FORM_DATA,
        ...STEP_3_EMAIL_FORM_DATA,
        to: customersToInsert,
        cc: STEP_3_EMAIL_FORM_DATA.cc.map(item => ({email: item})),
        bcc: STEP_3_EMAIL_FORM_DATA.bcc.map(item => ({email: item})),
        massOrigin: route.query.massOrigin * 1,
        teamId: teamId.value,
        userId: Storage.get("userInfo")?.id || ''
      }

      if (STEP_3_EMAIL_FORM_DATA.checked1Time || STEP_3_EMAIL_FORM_DATA.checked2Location) {
        if (STEP_3_EMAIL_FORM_DATA.checked1Time) {
          payload.sendType = 1
        } else if (STEP_3_EMAIL_FORM_DATA.checked2Location) {
          payload.sendType = 2
        } else {
          payload.sendType = null
        }
      } else {
        payload.sendType = null
        payload.zoneAddress = null
        payload.sendTime = null
      }
      if (STEP_3_EMAIL_FORM_DATA.checked2Location) {
        payload.zoneAddress = null
      }
      // 特殊处理 subject
      let newSubject = STEP_3_EMAIL_FORM_DATA.subjectList.map(_ => _.content)
      payload.subjectList = newSubject;

      console.log(payload, 'payload')

      // return
      // setTimeout(() => {
      //   resetAllLocationData()
      //   router.push("/email/customer/sending")
      // }, 4000)
      // return

      if (route.query.taskId) {
        payload.massTaskId = route.query.taskId;
      }
      const targetMassOrigin = route.query.massOrigin * 1;
      const requestApi = (route.query.taskId && targetMassOrigin === 2) ? sendMassMailUpdate : sendMassMail
      loadingSend.value = true
      requestApi(payload)
          .then(async (res) => {
            loadingSend.value = false
            if (res.code === 200) {
              console.log(res, 'sendSuccess')
              if (targetMassOrigin === 1 || targetMassOrigin === 2 || targetMassOrigin === 4) {
                //  新增任务
                await resetAllLocationData()
                router.push("/email/customer/sending")
              } else if (targetMassOrigin === 3) {
                await resetAllLocationData()
                await followCustomer()
                router.push("/email/customer/follow")
              }
            }
          })
          .catch((e) => {
            loadingSend.value = false
            console.log(e, 'e')
          })
          .finally(() => {
            // this.loading = false;
            loadingSend.value = false
            if (route.query.type === '2') {
              //   更新营销邮件
              store.dispatch("cloud/queryByUserIdApis");
            }
          });
    }
  }
}, TIME_OUT)


// 重置所有的数据
const resetAllLocationData = async () => {
  await Promise.all([
    UserTable.clear(),
    sessionStore.remove("STEP_0_SELECT_TYPE"),
    sessionStore.remove("STEP_0_SELECT_WAYS"),
    sessionStore.remove("STEP_1_RULE"),
    sessionStore.remove("STEP_2_EMAIL_FORM_DATA"),
    sessionStore.remove("STEP_3_EMAIL_FORM_DATA"),
    // sessionStore.remove("sendDetailEmailArray")
  ])
  console.log('✅ 所有缓存已清除')
}

const resetOtherData = async () => {
  await Promise.all([
    sessionStore.remove("STEP_FOLLOW_CUSTOMER"),
    sessionStore.remove("STEP_TASK_TARGET_EMAIL")
  ])
}

// 客户跟进
const followCustomer = async () => {
  const customerTable = await CustomerTable.getAll()
  const idList = customerTable.map(item => ({id: item.id}))
  // 跟进取消内容
  let targetObj = {
    mailCustomerFollowListDTOList: idList,
    teamId: teamId.value,
    type: 2,
  };
  console.log(targetObj, "targetObj");
  // return
  let res = await batchDelayCancel({...targetObj});
  if (res.code !== 200) {
    ElMessage.error(res.message);
    return;
  }
  await store.dispatch('countshow/getTeamAllDataApis')
}

const currentMassEmailObj = ref({})
const isDetailLoading = ref(false)

const payloadFormEmail = ref({})
const getEmailDetail = async () => {
  try {
    const sendDetailEmailArray = sessionStore.get("sendDetailEmailArray")
    const payload = {
      massTaskId: route.query.taskId,
      teamId: teamId.value,
      emailList: sendDetailEmailArray,
    }
    isDetailLoading.value = true;
    const res = await getMassMailDetail(payload)
    isDetailLoading.value = false
    console.log(res, 'detail')
    currentMassEmailObj.value = res.result;
    await sessionStore.set("STEP_0_SELECT_TYPE", res.result?.massMarketType)
    await sessionStore.set("STEP_0_SELECT_WAYS", res.result?.massMailType)


    //  结果页的数据
    const targetDataList = res.result?.toList
    console.log(targetDataList, 'targetDataList')
    const targetList = targetDataList.map(item => {
      const obj = {
        email: item.email || "",
        customerName: item.customerName !== '' ? item.customerName : "",
        customerCode: item.customerCode || "",
        contactName: item.contactName !== '' ? item.contactName : "",
        zoneAddress: item.zoneAddress || "",
        zoneCode: item.zoneCode || "",
        isCheck: 1,
        type: item.type || 2,
        contactId: item.contactId ?? null
      }

      // 如果存在 customerId，则添加
      if (item.customerId) {
        obj.customerId = item.customerId;
      }
      if (item.id) {
        obj.customerId = item.id
      }
      if (item.contactId) {
        obj.contactId = item.contactId;
      }
      return obj
    })

    // 结果页数据 选择数据
    if (route.query.massOrigin * 1 === 4 && route.query.select * 1 === 1) {
      let resList = await sessionStore.get("STEP_TASK_TARGET_EMAIL")
      const emailListData = resList.map(item => item.toEmail)
      const list = targetList.filter(_ => emailListData.includes(_.email))
      console.log(resList, emailListData, list, 'emailListData')
      await UserTable.bulkAdd(list)
    } else {
      await UserTable.bulkAdd(targetList)
    }


    //   表单的数据
    const {
      taskName,
      configId,
      remark,
      title,
      sendTime,
      replyMail,
      ccList,
      bccList,
      nickName,
      zoneAddress,
      sendTimeInterval,
      sendType,
      massContent,
      readTrack,
      receipt,
      mailMassExtendVoList,
      urgent,
    } = res.result

    // 邮件内容页面
    const formData = {
      text: massContent,
      readTrack: readTrack ? readTrack : false,
      receipt: receipt ? receipt : false,
      urgent: urgent ? urgent : false,
      multipartFiles: mailMassExtendVoList
    }
    await sessionStore.set("STEP_2_EMAIL_FORM_DATA", formData)


    const subjectArray = title.split("####").map(item => ({content: item}))

    const configIdList = userMail_dropDownOptionList.value.filter(it => configId.split(",").includes(it?.configId));
    console.log(subjectArray, configIdList, userMail_dropDownOptionList.value, 'subjectArray')

    const payloadForm = {
      taskName: taskName,
      mailMassConfigDtoList: configIdList,
      remark: remark,
      subjectList: subjectArray,
      sendTime: sendTime,
      replyTo: replyMail,
      cc: ccList.map(item => item.email),
      bcc: bccList.map(item => item.email),
      isCheckCC: ccList.length > 0,
      isCheckBCC: bccList.length > 0,
      nickName: nickName,
      zoneAddress: zoneAddress,
      checked1Time: sendType === 1,
      checked2Location: sendType === 2,
      massSendSecond: sendTimeInterval,
    }
    console.log(payloadForm, 'payloaddddddd')
    payloadFormEmail.value = payloadForm
    await sessionStore.set("STEP_3_EMAIL_FORM_DATA", payloadForm)
  } catch (e) {
    console.log(e, 'error')
    isDetailLoading.value = false
  }
}

// 获取规则
const getRule = async () => {
  try {
    const payload = {
      id: route.query.taskId,
      teamId: teamId.value,
    }
    const res = await getRuleFilter(payload)
    console.log(res, res.result?.jsonText, 'respayload')
    const jsonParse = JSON.parse(res.result?.jsonText ?? '')
    await sessionStore.set("STEP_1_RULE", jsonParse)
  } catch (e) {

  }
}

const massOrigin = ref(0)
// (1:普通群发新增,2:普通群发编辑,3:客户跟进新增,4:客户群发重发")
const getSwitchDetailAPI = async () => {
  // 每次切换都先重置状态
  steps.value[current.value].status = 'process'

  if (current.value === 0) {
    // 第0步：初始化
    console.log('初始化')
  } else if (current.value === 1) {
    // 判断不同来源
    if (massOrigin.value === 2) {
      console.log("编辑模式")
    } else if (massOrigin.value === 3) {

    } else if (current.value === 2) {
      // 邮件内容
      console.log("邮件内容设置")
    } else if (current.value === 3) {
      // 发送设置
      console.log("发送设置")
    }
  }


  // if (massOrigin.value === 3) {
  //   // console.log("客户批量跟进模式")
  //   // 第1步：任务设置
  //   const STEP_0_SELECT_TYPE = sessionStore.get("STEP_0_SELECT_TYPE")
  //   const STEP_0_SELECT_WAYS = sessionStore.get("STEP_0_SELECT_WAYS")
  //
  //   // 判断是否有数据
  //   if (!STEP_0_SELECT_TYPE && !STEP_0_SELECT_WAYS) {
  //     // 没数据 -> 标记为 error 并提示
  //     steps.value[0].status = "error"
  //     // ElMessage.error("请先完成任务设置")
  //     // return false // ❌ 阻止继续执行
  //   }
  //
  //   // ✅ 有数据 -> 正常执行逻辑
  //   console.log("已设置任务类型和方式", STEP_0_SELECT_TYPE, STEP_0_SELECT_WAYS)
  //   steps.value[current.value].status = "finish"
  //   return true
  // }
}

onMounted(async () => {
  // 首先重置防止缓存脏数据
  await resetAllLocationData()
  const currentTarget = route.query.step * 1
  massOrigin.value = route.query.massOrigin * 1
  console.log(currentTarget, 'currentTarget')
  if (currentTarget !== undefined) {
    updateStep(currentTarget)
    console.log(steps.value, 'steps.value')
    current.value = currentTarget
    sessionStore.set("STEP_CURRENT", currentTarget)
  }
  await getSwitchDetailAPI()
  if (route.query.taskId) {
    //   获取任务详情
    await initUserMailList();
    await getEmailDetail()
    //   获取规则
    await getRule()
  }
})


const userMail_dropDownOptionList = ref([]);
const configMapSysUser = reactive({});
const configIdMapUserName = reactive({});
const userNameMap = reactive({});

function initUserMailList() {
  // currentMailId = this.mailConfigId;
  return getMailConfigList({teamId: teamId.value}).then((res) => {
    console.log(res, '获取用户邮箱列表');
    if (res.code === 200) {
      // const mailMassConfigDtoList = res.data.data[0].id
      res.result = res.result || [];
      const arr = [];
      res.result.forEach((item) => {
        configMapSysUser[item.id] = item.sysUserId;
        configIdMapUserName[item.username] = item.id;
        userNameMap[item.id] = item.username;
        arr.push({from: item.username, configId: item.id});
      });
      userMail_dropDownOptionList.value = arr;
    }
  });
}

</script>
<style scoped lang="less">
.steps-content {
  margin-top: 20px;
  min-height: 200px;
  height: 50%;
  //background: red;
  text-align: center;
}

.steps-action {
  position: fixed;
  height: 8vh;
  line-height: 8vh;
  width: 100%;
  text-align: right;
  padding-right: 40px;
  bottom: 0px;
  border-top: 2px solid #f7f7f7;
}

[data-theme='dark'] .steps-content {
  background-color: #2f2f2f;
  border: 1px dashed #404040;
}

.content {
  .step_content {
    height: 84px;
    line-height: 84px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0px 323px;
    border-bottom: 2px solid #f7f7f7;
  }
}

:deep(.el-dialog__header) {
  display: flex !important;
}

:deep(.ant-steps-item-finish .ant-steps-item-title) {
  color: #1890FF !important;
}
</style>
